function initializeComparison(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  let request, cheaper = false;
  const status = text => { root.querySelector('[data-comparison-status]').textContent = text; };
  function filterCards() {
    const cards = [...root.querySelectorAll('[data-comparison-card]')];
    cards.forEach(card => { card.hidden = cheaper && card.dataset.cheaper !== 'true'; });
    const empty = root.querySelector('[data-cheaper-empty]');
    if (empty) empty.hidden = !cheaper || cards.some(card => !card.hidden);
  }
  async function update() {
    const form = root.querySelector('form');
    if (!form) return; // compact block (VDP): no filters to submit
    const focusId = document.activeElement?.id;
    request?.abort();
    const controller = new AbortController(); request = controller;
    root.setAttribute('aria-busy', 'true'); status('Updating comparison…');
    try {
      const url = new URL(form.action); url.search = new URLSearchParams(new FormData(form));
      const response = await fetch(url, { headers: {Accept: 'application/json'}, signal: controller.signal });
      if (!response.ok) throw new Error('Unavailable');
      const data = await response.json();
      if (controller !== request) return;
      root.innerHTML = data.html;
      const only = root.querySelector('[data-cheaper-only]'); if (only) only.checked = cheaper;
      filterCards();
      if (focusId) root.querySelector(`#${CSS.escape(focusId)}`)?.focus({preventScroll: true});
      status('Comparison updated.');
    } catch (error) {
      if (error.name !== 'AbortError') status('Could not update. The previous results remain below. Please retry.');
    } finally { if (controller === request) root.removeAttribute('aria-busy'); }
  }
  root.addEventListener('submit', event => { event.preventDefault(); update(); });
  root.addEventListener('change', event => {
    if (event.target.matches('[data-cheaper-only]')) { cheaper = event.target.checked; filterCards(); }
    else if (event.target.matches('select')) update();
  });
  root.addEventListener('error', event => {
    const img = event.target;
    if (!img.matches?.('[data-comparison-photo]')) return;
    const note = document.createElement('span');
    note.textContent = 'Listing photo is no longer available';
    img.replaceWith(note);
  }, true);
}
function initialize() { document.querySelectorAll('[data-vehicle-comparison]').forEach(initializeComparison); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
document.addEventListener('turbo:load', initialize);
